//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import { Button } from "@mui/material";
import { globalConfig } from "../../config/config";
const axios = require('axios');



export default class ViewVCSLabels extends Component {

	
	constructor(props)
	{
		console.log(props);
		super(props);
	}
	state = {
    vcsLabels: []
  	};

	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
      axios.get(`${globalConfig.apiDatahubUrl}/vcs-labels/`, globalConfig.hardcoded_header).then(res => {
      const vcsLabels = res.data;
      console.log(vcsLabels);
      this.setState({ vcsLabels });
      console.log(res.data[0]);
		});
		
	}

	render(){

        return (

			<form>
		
				<div class="container-fluid">
		<div style={{display: "flex", justifyContent: "space-between"}}>
			  <h4>Version Labels</h4>
			  <div>
			  <Link to="/waves">
			  	<Button variant="contained">Go Back</Button>
			  </Link>
			  </div>
		</div>
		<hr />
				<div class="form-group row">
					<label class="ContentTitle">Version Label</label>
					<input class="form-input input-xlarge col-sm-4"></input>					
					<label class="ContentTitle">Expiration Date</label>
					<input class="form-input input-xlarge col-sm-1"></input>&nbsp;	
					<button class="btn btn-success">Create Label</button>
				</div>
				<hr />
      <div className="form-group row">
      	<table class="table table-bordered table-striped">
      	<thead>
      	<tr>
      	<th scope="col">#</th>
      	<th scope="col">Version Label</th>
     	<th scope="col">Created On</th>
     	<th scope="col">Created By</th>
     	<th scope="col">Label Expires On</th>
     	<th scope="col">Action</th>
    	</tr>
  		</thead>
  		<tbody>

          {this.state.vcsLabels.map( ( {vcsLabelId, versionLabel, versionLabelTimestamp, versionLabelUserid, 
          							versionLabelExpTimestamp} ) => {
  					  return <tr><
  					  	td>{vcsLabelId}</td>
  					  	<td>{versionLabel} </td>
  					  	<td> {versionLabelTimestamp}</td>
  					  	<td> {versionLabelUserid}</td>
  					  	<td> {versionLabelExpTimestamp}</td>
						<td>
  					  		<button class="btn btn-danger">Delete</button>
  					  	</td>
  					  	</tr>
					}) 
				}
        </tbody>
        </table>
      </div>
      </div>
		
			
	</form>
);
}
}
